import React from 'react'
import { API_SERVICES } from '..'
import QSubcategoria from '../../libQuestionario/pages/QSubcategoria'
import MRHeader from './components/MRHeader'


const MRSubcategoria = () => {
  return <QSubcategoria
    homeRoute={API_SERVICES.MR.HOME_ROUTE}
    root={API_SERVICES.MR.ROOT}
    title={API_SERVICES.MR.NOME}
    headerComponent={<MRHeader label="Seleziona un modello" />}
  />
}

export default MRSubcategoria;